import styled from 'styled-components';

export const Content = styled.div`
  font-family: 'Lato';
  padding: 1rem;
`;

export const Icon = styled.div`
  font-size: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 64px;
  width: 36px;

  svg {
    transform: rotate(0deg);
    transition: all 125ms;
  }

  &.rotate-enter-active svg {
    transform: rotate(-90deg);
  }

  &.rotate-enter-done svg {
    transform: rotate(-90deg);
  }

  &.rotate-exit-enter svg {
    transform: rotate(-90deg);
  }

  &.rotate-exit-active svg {
    transform: rotate(0deg);
  }
`;

export const FileIcon = styled(Icon)`
  background-color: ${({ theme }) => theme.qfb3};
  border-radius: 10px 0 0 10px;
  color: white;
`;

export const Label = styled.div`
  flex-grow: 1;
  font-family: 'Montserrat';
  padding: 0.5rem;
`;

export const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  margin-bottom: 1rem;
`;

export default styled.div`
  border-radius: 10px;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;

  &.expanded {
    background: #000000;
  }

  &:hover {
    background: #111111;
    ${FileIcon} {
      background-color: ${({ theme }) => theme.qfb4};
    }
  }
`;
